export default function Loading(params) {
    const content = document.createElement('div');
    content.classList.add('w5-loader-cell');

    const loaderGroup = document.createElement('div');
    loaderGroup.classList.add('w5-loader-cell__group');

    const loader = document.createElement('div');
    loader.classList.add('w5-loader-cell__spinner');

    loaderGroup.appendChild(loader);
    content.appendChild(loaderGroup);
    return content;
}
